export type Theme = "neon" | "tam";

/** tam.sikile.si (any host starting with "tam.") or ?tam in the URL selects the dark-humour edition. */
export function detectTheme(loc: Pick<Location, "hostname" | "search">): Theme {
  if (loc.hostname.toLowerCase().startsWith("tam.")) return "tam";
  return new URLSearchParams(loc.search).has("tam") ? "tam" : "neon";
}

/** Absolute permalink of a topic on the given edition. */
export function permalink(topicId: string, theme: Theme, loc: Pick<Location, "origin" | "hostname" | "protocol" | "port">): string {
  const path = `/b/${topicId}`;
  const isTamHost = loc.hostname.toLowerCase().startsWith("tam.");
  if (theme === "neon") {
    if (!isTamHost) return `${loc.origin}${path}`;
    return `${loc.protocol}//${loc.hostname.slice(4)}${loc.port ? `:${loc.port}` : ""}${path}`;
  }
  if (isTamHost) return `${loc.origin}${path}`;
  // Production host gets the tam. subdomain; localhost and preview hosts use ?tam.
  if (/^(localhost|127\.|\[::1\]|.*\.pages\.dev$)/.test(loc.hostname)) return `${loc.origin}${path}?tam`;
  return `${loc.protocol}//tam.${loc.hostname}${loc.port ? `:${loc.port}` : ""}${path}`;
}
